<template>
    <div class="modern-tour-card w-full sm:w-1/2 lg:w-1/3 max-w-full px-3 mb-6" v-if="!checkPackageIds.includes(tourPackage.package_id)">
        <div class="tour-card-item bg-white border border-[var(--bone-dark)] hover:border-[var(--primary)] h-full rounded-lg transition-all duration-300 overflow-hidden">
            <div class="tour-content w-full p-3 sm:p-6 bg-white h-[calc(100%-57px)] sm:h-[calc(100%-70px)]">
                <div class="tour-image-wrapper bg-[var(--light-gray)] rounded-md w-full h-60 mb-4">
                    <img v-if="tourPackage.FrontendPackageImage" 
                        :src="tourPackage.FrontendPackageImage" 
                        :alt="tourPackage.package_name"
                        class="tour-image w-full h-full object-cover object-center">
                    <div v-else class="tour-image-placeholder w-full h-full flex items-center justify-center flex-col p-3">
                        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                            <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path>
                            <polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline>
                            <line x1="12" y1="22.08" x2="12" y2="12"></line>
                        </svg>
                        <p class="placeholder-text text-[15px] text-[#9CA3AF] uppercase mt-2">Image coming soon</p>
                    </div>
                </div>
                <h3 class="tour-title text-lg lg:text-[22px] font-bold text-[var(--charcoal)] mb-2">{{ tourPackage.package_name }}</h3>
                <p class="tour-description text-[15px] text-[var(--charcoal-gray)]">{{ tourPackage.short_description }}</p>
            </div>
            <div class="tour-footer w-full px-3 pb-3 sm:px-6 sm:pb-6 bg-white">
                <button class="btn-select-tour btn-primary" data-track="select_tour" :data-track-tour="tourPackage.package_id"
                    @click="$emit('book-now', { 
                        tenant_id: tourPackage.tenant_id, 
                        tour_operator_id: tourPackage.tour_operator_id, 
                        package_id: tourPackage.package_id 
                    })">
                    <span>Select Tour</span>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'AvailablePackage',
    props: ['tourPackage', 'checkPackageIds'],
    emits: ['book-now'],
};
</script>